import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/instances';
import ShowPasswordIcon from './ShowPasswordIcon';

function mapStateToProps(state, ownProps) {
  return {
    instanceService: selectors.instanceServiceSelector(state, ownProps),
  };
}

const mapDispatchToProps = {
  getInstanceWithPassword: actionCreators.getInstanceWithPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowPasswordIcon);
